import { URI_MESSAGES_SERVICE } from '@/config/config';
export default async (bearerToken, payload) => {
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',

      Authorization: `Bearer ${bearerToken}`,
    },
    body: JSON.stringify(payload),
  };
  const response = await fetch(
    `${URI_MESSAGES_SERVICE}messages/set-received`,
    opts,
  );
  const jsonResult = await response.json();
  if (response.status >= 400) {
    throw new Error(jsonResult);
  }
};
